import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import api from './services/api';
import { getCachedSiteName, saveSiteName, DEFAULT_SITE_NAME } from './utils/siteName';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import AnnouncementPopup from './components/AnnouncementPopup';
import Home from './pages/Home';
import Videos from './pages/Videos';
import Documents from './pages/Documents';
import Leaderboard from './pages/Leaderboard';
import VIPCenter from './pages/VIPCenter';
import Quiz from './pages/Quiz';
import Login from './pages/Login';
import Register from './pages/Register';
import './styles/App.css';

function App() {
  // 动态加载网站名称并更新浏览器标题
  useEffect(() => {
    const cached = getCachedSiteName();
    document.title = cached || DEFAULT_SITE_NAME;

    const loadSiteName = async () => {
      try {
        const response = await api.get('/settings/siteName');
        if (response.data.success && response.data.data) {
          saveSiteName(response.data.data);
        } else {
          document.title = DEFAULT_SITE_NAME;
        }
      } catch (error) {
        console.error('Failed to load site name:', error);
      }
    };
    loadSiteName();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="app">
          <AnnouncementPopup />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/*" element={
              <>
                <Navbar />
                <main className="main-content">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/videos" element={<Videos />} />
                    <Route path="/documents" element={<Documents />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route path="/vip" element={<VIPCenter />} />
                    <Route path="/quiz" element={<Quiz />} />
                  </Routes>
                </main>
              </>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
